import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "position-relative d-flex justify-content-center" }
const _hoisted_2 = {
  key: 0,
  class: "absolute-animate"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white" }, [
  /*#__PURE__*/_createTextVNode(" Iniciando Sesión "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "en ChatCenter")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "absolute-animate"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", {
  class: "text-light",
  style: {"animation-duration":"0.3s"}
}, [
  /*#__PURE__*/_createTextVNode(" Iniciando Sesión "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "en CallCenter")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { AuthModule } from "@/store/modules/Auth";
import { AuthStatus } from "types/router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "miniFadeUp" }, {
      default: _withCtx(() => [
        (_unref(AuthModule).status === _unref(AuthStatus).LOADING_CHAT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_unref(AuthModule).status === _unref(AuthStatus).LOADING_CALL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})